import { type UserQuizStateInfoDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface Params {
  userQuizId?: string;
}

type Response = UserQuizStateInfoDto | undefined;

interface Return {
  isGettingQuizState: boolean;
  quizState: Response;
  quizStateError: AxiosError | null;
}

export const useGetUserQuizState = ({ userQuizId }: Params): Return => {
  const { restUserQuizApi } = useApiClient();
  const { user } = useUserContext();
  const { data, error, isLoading } = useQuery<Response, AxiosError>({
    enabled: !!(user?.userId && userQuizId),
    queryFn: async () => {
      if (user?.userId && userQuizId) {
        const response = await restUserQuizApi.getUserQuizState(user?.userId, userQuizId);

        return response.data;
      }
    },
    queryKey: [QueryKeyEnum.GET_QUIZ_STATE, user?.userId, userQuizId],
  });

  return {
    isGettingQuizState: isLoading,
    quizState: data,
    quizStateError: error,
  };
};
